import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { type Modification } from 'src/types/modification';

import ModificationService from '../components/pages/adminConfiguration/modificationConfig/service/modificationService';

interface ModificationsState {
  modifications: Modification[];
}

const initialState: ModificationsState = { modifications: [] };

// **** API Calls **** //

export const getModifications = createAsyncThunk('modifications/getModifications', async () => {
  return await ModificationService.getModifications();
});

// **** Setup Slice **** //

// "Modifications Slice"
const { reducer } = createSlice({
  name: 'modificationsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getModifications.fulfilled, (state, { payload }) => {
      state.modifications = payload;
    });
  },
});

export default reducer;
